import SingUpModal from '@/components/Modals/SingUpModal';
import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import UpgradeImage from '@/images/SPPlus.png';
import { useAuth } from '@/services/auth';
import { annoynmousUserToEditorPagePostSsoReturnTo } from '@/utils/utils';
import styled from '@emotion/styled';

const SubText = styled.div`
    font-size: 1.6rem;
    font-weight: 400;
    padding-top: 2rem;
`;

interface Props {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const UpgradeModal = ({ open, setOpen }: Props) => {
    const { isAnonymous, loginWithRedirect } = useAuth();

    if (isAnonymous) {
        return (
            <SingUpModal
                text="Sign up to create this video"
                mainText="By signing up you will receive 20 credits you can use."
                from="agent-editor"
                isOpen={open}
                onClose={() => setOpen(false)}
            />
        );
    }

    return (
        <UpgradePlanModal
            open={open}
            onClose={() => setOpen(false)}
            from={'SP+ presenter clicked'}
            imageFile={UpgradeImage}
            ctaText={'Upgrade'}
            title={
                isAnonymous ? (
                    <div>
                        Signup to generate this video
                        <br />
                        <SubText>By signing up you will receive 20 credits you can use immediately</SubText>
                    </div>
                ) : (
                    <div>
                        Upgrade to higher plan
                        <br />
                        and enjoy premium presenters
                    </div>
                )
            }
            ctaAction={
                isAnonymous
                    ? () => {
                          loginWithRedirect({
                              screen_hint: 'signup',
                              appState: { returnTo: annoynmousUserToEditorPagePostSsoReturnTo },
                          });
                      }
                    : undefined
            }
        />
    );
};
